import { gql } from "graphql-request";
import { Language } from "./languages";
import { Country } from "./countries";
import axios from "axios";
import {baseUrl} from "../config";
import {queryGraphQL} from "./backend";

export enum Privilege {
  Admin = "ADMIN",
}

export type User = {
  email: string;
  name?: string;
  picture?: string;
  id?: number;
  token?: string;
  privileges?: Array<Privilege>;
};

export const backOfficeLogin = (
  idToken: string,
  language: Language = Language.EN,
  country: Country = Country.GB
) => {
  const url = `${baseUrl}/auth/back-office-login`;


  return axios.post(url, {
    jwtToken: idToken,
  });
};

export type ActiveUserSession = {
  email: string;
  lastActiveSecs?: number;
};

export const getActiveUserSessions = async (user:User) => {
  const query = gql`
    query ActiveUserSessions($sessionId: Int!, $sessionToken: String!) {
      activeUserSessions(sessionId: $sessionId, sessionToken: $sessionToken)
    }
  `;
  return await queryGraphQL<Array<ActiveUserSession>>(
    query,
    { sessionId:user.id, sessionToken: user.token },
    "activeUserSessions"
  );
};

// Types for Clerk user list API
export type ClerkUser = {
  id: string;
  emailAddresses: Array<{
    id: string;
    emailAddress: string;
  }>;
  firstName?: string;
  lastName?: string;
  createdAt: number;
  updatedAt: number;
  lastSignInAt?: number;
  banned?: boolean;
  [key: string]: any; // For other Clerk user fields
};

export type ListUsersResponse = {
  data: ClerkUser[];
  totalCount: number;
};

export type ListUsersParams = {
  limit?: number;
  offset?: number;
};

export const listUsers = async (
  params?: ListUsersParams
): Promise<{ data?: ListUsersResponse; error?: string }> => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.limit !== undefined) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params?.offset !== undefined) {
      queryParams.append("offset", params.offset.toString());
    }

    const url = `${baseUrl}/auth/list-users${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
    const response = await axios.get<ListUsersResponse>(url);
    return { data: response.data };
  } catch (err: any) {
    if (err.response?.data?.error) {
      return { error: err.response.data.error };
    }
    if (err.message) {
      return { error: err.message };
    }
    return { error: String(err) };
  }
};

export const banUser = async (
  userId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const url = `${baseUrl}/auth/ban-user`;
    const response = await axios.post(url, { user_id: userId });
    return { data: response.data };
  } catch (err: any) {
    if (err.response?.data?.error) {
      return { error: err.response.data.error };
    }
    if (err.message) {
      return { error: err.message };
    }
    return { error: String(err) };
  }
};

export const unbanUser = async (
  userId: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const url = `${baseUrl}/auth/unban-user`;
    const response = await axios.post(url, { user_id: userId });
    return { data: response.data };
  } catch (err: any) {
    if (err.response?.data?.error) {
      return { error: err.response.data.error };
    }
    if (err.message) {
      return { error: err.message };
    }
    return { error: String(err) };
  }
};
